import * as React from 'react';
import { FormControl } from '@mui/material';
import { FieldArray } from 'redux-form';
import { useTranslation } from 'react-i18next';
import { DynamicComponentInput, DynamicFormFieldArray, renderDynamicComponent } from './DynamicComponent';
import { FieldNames } from '../../../models/fields/names';
import { DynamicFormFieldArrayType } from '../../../models/options/enums';
import { lienHolderInitialValue } from '../../../util/initial-values';
import { NAME_SUFFIX_OPTIONS } from '../../../models/options/options';
import { noopValidate } from '../../../util/validators';

const lienHolderInputs: DynamicComponentInput[] = [
  {
    fieldName  : FieldNames.lienHolderFirstName,
    isOptional : true,
    label      : 'First Name',
    type       : DynamicFormFieldArrayType.NAME,
  },
  {
    fieldName  : FieldNames.lienHolderMiddleName,
    isOptional : true,
    label      : 'Middle Name',
    type       : DynamicFormFieldArrayType.NAME,
  },
  {
    fieldName  : FieldNames.lienHolderLastName,
    isOptional : true,
    label      : 'Last Name',
    type       : DynamicFormFieldArrayType.NAME,
  },
  {
    fieldName  : FieldNames.lienHolderSuffixName,
    isOptional : true,
    label      : 'Suffix',
    options    : NAME_SUFFIX_OPTIONS,
    type       : DynamicFormFieldArrayType.SELECT,
  },
];

const lienHolderProps: DynamicFormFieldArray = {
  addButtonText : 'Lien Holder',
  allowEmpty    : true,
  initialValue  : lienHolderInitialValue,
  inputs        : lienHolderInputs,
};

export const LienHoldersComponent = ({ ...props }) => {
  const { name } = props;
  const { t }    = useTranslation();

  return (
    <FormControl fullWidth>
      <FieldArray
        component = {renderDynamicComponent}
        name      = {name}
        props     = {{ dynamicProps: lienHolderProps, name, t }}
        validate  = {[noopValidate]}
      />
    </FormControl>
  );
};
